import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IUserModel } from 'models/user.model'
import { IPermissionModel } from 'models/permission.model'

export const USER_UPLOAD = 'USER_UPLOAD'
export const USER_UPLOAD_SUCCESS = 'USER_UPLOAD_SUCCESS'
export const DECODE_JWT = 'DECODE_JWT'
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
export const GET_PERMISSIONS = 'GET_PERMISSIONS'
export const GET_PERMISSIONS_SUCCESS = 'GET_PERMISSIONS_SUCCESS'
export const UPDATE_USER_SUPERVISORS = 'UPDATE_USER_SUPERVISORS'
export const UPDATE_USER_SUPERVISORS_SUCCESS = 'UPDATE_USER_SUPERVISORS_SUCCESS'
export const SEARCH_USER_LIST = 'SEARCH_USER_LIST'
export const SEARCH_USER_LIST_SUCCESS = 'SEARCH_USER_LIST_SUCCESS'

export interface SearchSuccessPayload {
  data: IUserModel[]
  total: number
  perPage: number
}

export type SearchSuccess = {
  type: typeof SEARCH_USER_LIST_SUCCESS
  payload: SearchSuccessPayload
}

export type Void = {
  type: typeof USER_UPLOAD | typeof SEARCH_USER_LIST | typeof GET_PERMISSIONS
  payload: SearchSuccessPayload
}

export type UpdateUser = {
  type: typeof UPDATE_USER_DATA
  payload: IUserModel
}

export type GetPermissions = {
  type: typeof GET_PERMISSIONS_SUCCESS
  payload: IPermissionModel
}

export type UpdateUserSupervisorsAction = {
  type: typeof UPDATE_USER_SUPERVISORS
  payload: {
    userId: number
    supervisors: string[]
    onSuccess?(data: IUserModel[]): void
    onError?(e: any): void
  }
}

export type UpdateUserSupervisorsSuccessAction = {
  type: typeof UPDATE_USER_SUPERVISORS_SUCCESS
  payload: IUserModel[]
}

interface SearchPayload {
  page?: number
  area?: string
  searchText?: string
  perPage?: number
  fastFilters?: number
  sort?: any[]
  usersFilter?: string
}

export type SearchAction = {
  type: typeof SEARCH_USER_LIST
  payload: SearchPayload
}

export type ReducerActions =
  | SearchSuccess
  | SearchAction
  | UpdateUser
  | GetPermissions
  | UpdateUserSupervisorsAction
  | UpdateUserSupervisorsSuccessAction
  | Void

export const Actions = {
  userUploadSuccess: (data: any) => createAction(USER_UPLOAD_SUCCESS, data),
  updateUser: (data: UpdateUser['payload']) =>
    createAction(UPDATE_USER_DATA, data),
  permissions: (data: GetPermissions['payload']) =>
    createAction(GET_PERMISSIONS_SUCCESS, data),
  search: (data?: SearchPayload) => createAction(SEARCH_USER_LIST, data),
  searchSuccess: (data: SearchSuccessPayload) =>
    createAction(SEARCH_USER_LIST_SUCCESS, data),
  updateUserSupervisors: (data: UpdateUserSupervisorsAction['payload']) =>
    createAction(UPDATE_USER_SUPERVISORS, data),
  updateUserSupervisorsSuccess: (
    data: UpdateUserSupervisorsSuccessAction['payload']
  ) => createAction(UPDATE_USER_SUPERVISORS_SUCCESS, data),
}

export type Actions = ActionsUnion<typeof Actions>
